import React, { useState } from 'react';
import { Grid, Paper, } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useLocation } from 'react-router-dom';
import { createRows, createHeaders, cleanupRowCount } from "../methods"

const QueryResult = () => {
    const location = useLocation();
    let state = JSON.parse(location.state)
    const { rowCount, response } = state;

    const headers = createHeaders(response);
    const rows = createRows(response);
    const count = cleanupRowCount(rowCount);

    return (
        <Grid container>
            <Grid size={12} padding={3}>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        autoHeight={true}
                        columns={headers}
                        rowCount={count}
                        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                        pageSizeOptions={[5, 10]}
                        disableRowSelectionOnClick
                        slots={{ toolbar: GridToolbar }}
                        showToolbar />
                </Paper>
            </Grid>
        </Grid>
    );
}

export default QueryResult;